module.exports = __webpack_public_path__ + "static/media/cell-phone.c91a61fc.svg";